import { usePageTitleContext } from "context/PageTitleContext";

import styles from "./PageTitle.module.css";

const PageTitle = ({ title }) => {
    const { title: contextTitle } = usePageTitleContext();
    const resolvedTitle = title ?? contextTitle;

    return (
        <div className={styles.PageTitle} data-testid="page-title">
            <h1 className="text-2xl font-bold mb-4">{resolvedTitle}</h1>
        </div>
    );
};

export default PageTitle;
